/**
 * PIN de acceso del portal QR/app móvil cuando el tenant activó el modo
 * restringido — ver ConfiguracionPortalQR en el backend.
 *
 * Se guarda una sola vez por dispositivo (localStorage, mismo mecanismo que
 * deviceId.js) y de ahí en más viaja solo en cada request vía el interceptor
 * de apiClient — nadie más tiene que acordarse de mandarlo a mano.
 */

const PIN_STORAGE_KEY = 'fcPortalPin';
export const PIN_HEADER = 'X-Portal-Pin';

export function getPinGuardado() {
  try {
    return localStorage.getItem(PIN_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function guardarPin(pin) {
  try {
    localStorage.setItem(PIN_STORAGE_KEY, pin);
  } catch {
    // Sin localStorage disponible (modo privado, storage bloqueado) el PIN
    // no persiste entre requests: cada acción lo va a volver a pedir. No hay
    // nada mejor que hacer acá sin romper el flujo.
  }
}

export function borrarPin() {
  try {
    localStorage.removeItem(PIN_STORAGE_KEY);
  } catch {
    // Ver guardarPin.
  }
}

const portalPin = { getPinGuardado, guardarPin, borrarPin, PIN_HEADER };
export default portalPin;
